<template>
    <div class="function_content">
        <div class="header">
            <div class="left">{{ $t('channel.function') }}</div>
            <div class="saveBtn" @click="save">
                <i class="guoran-tongyichicun-16-03-baocun iconfont"></i>
                {{ $t('channel.save') }}
            </div>
        </div>
        <div class="function_c">
            <div class="switch_cont">
                <div class="online-search-title">
                    <div class="online-search-switch-cont">
                        <div class="online-search-switch">
                            <el-switch @click.native.prevent="changeSelectAgentEnable('switch')" :width="42"
                                v-model="selectAgent" active-color="#366AFF" inactive-color="#E2E2E2">
                                >
                            </el-switch>
                            <span class="switch-open-icon" @click="changeSelectAgentEnable('open')"
                                v-if="selectAgent"><i class="iconfont guoran-a-16-17"></i></span>
                            <span class="switch-close-icon" @click="changeSelectAgentEnable('close')"
                                v-if="!selectAgent"><i class="arsenal_icon arsenalcuo1"></i></span>
                        </div>
                        <div class="item-title">
                            {{ $t('channel.agentSwitching.title') }}
                        </div>
                    </div>
                    <div class="des">
                        {{ $t('channel.agentSwitching.description') }}
                        {{ $t('channel.agentSwitching.tip1') }}
                    </div>
                </div>
            </div>
            <div class="switch_cont">
                <div class="online-search-title">
                    <div class="online-search-switch-cont">
                        <el-switch :width="42"
                            v-model="enableFormAiReply" active-color="#366AFF" inactive-color="#E2E2E2">
                        </el-switch>
                        <div class="item-title">
                            {{ $t('channel.accessConfig.enableFormAiReply') }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="entry_cont">
              <div class="entry_title">
                {{ $t('channel.accessConfig.title') }}
              </div>
              <default-entry ref="defaultEntry" :bindDetail="bindDetail" :enable-form-ai-reply="enableFormAiReply"></default-entry>
            </div>
        </div>
        <DialogView :bindDetail="bindDetail" :agentBindBotInfos="bindDetail.wechatBindAgent ? bindDetail.wechatBindAgent.agentBindBotInfos : []"></DialogView>
    </div>
</template>

<script>
import DialogView from './dialogView.vue';
import DefaultEntry from "@/views/channelManage/components/defaultEntry";
export default {
    props: {
        bindDetail: {
            type: Object,
            default: () => ({}),
        },
    },
    components: {
      DefaultEntry,
        DialogView,
    },
    data() {
        return {
            selectAgent: false,
            enableFormAiReply: false,
            copyDetail: {},
        }
    },
    mounted() {
        this.selectAgent = this.bindDetail.selectAgent;
        if (this.bindDetail && this.bindDetail.accessConfig) {
            this.enableFormAiReply = JSON.parse(this.bindDetail.accessConfig).enableFormAiReply || false;
        }
        // this.copyDetail = JSON.parse(JSON.stringify(this.bindDetail))
    },
    methods: {
        save() {
            this.$http.post("/api-open/channel/access/update-select-agent?bindId=" + this.bindDetail.id + "&selectAgent=" + this.selectAgent).then(res => {
                if (res.data.code == 0) {
                    if (this.$refs.defaultEntry){
                      this.$refs.defaultEntry.updateConfig((ress) => {
                        if (ress.data.code == 0){
                          this.$message.success("保存成功")
                          this.$emit("saveSuccess", this.selectAgent)
                        } else {
                          this.$message.success("默认入口保存失败")
                        }
                      });
                    }
                } else {
                    this.$message.error("保存失败")
                }
            })

        },
        changeSelectAgentEnable(type) {
            if (type === "open") {
                this.$set(this.copyDetail, 'selectAgent', false)
                this.$set(this, 'selectAgent', false)
            } else if (type === "close") {
                this.$set(this.copyDetail, 'selectAgent', true)
                this.$set(this, 'selectAgent', true)
            } else {
                // this.$set(this.copyDetail, 'selectAgent', this.selectAgent)
            }
        },
    }
}
</script>

<style lang="less" scoped>
.function_content {
    height: 100%;
    width: calc(100% - 390px);
    // overflow: auto;
    background-color: #FFFFFF;
    box-sizing: border-box;
    padding: 20px;
    position: relative;


    .header {
        margin-bottom: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
            font-size: 16px;
            color: #000000;
        }
    }

    .saveBtn {
        height: 26px;
        background-color: #366aff;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 14px;
        font-size: 12px;
        border-radius: 17px;
        cursor: pointer;

        i {
            font-size: 12px;
            padding-right: 4px;
        }
    }

    .function_c {
        width: 100%;
        height: calc(100% - 50px);
        box-sizing: border-box;
        overflow-y: auto;
        overflow-x: hidden;

        .left_title {
            font-size: 14px;
            color: #000000;
            margin-bottom: 10px;
        }

        .switch_cont {
            margin-top: 20px;
            box-sizing: border-box;


        }
        .entry_cont{
          margin-top: 20px;
          .entry_title{
            margin-bottom: 12px;
            font-size: 14px;
          }
        }

        .online-search-title {
            .online-search-switch-cont {
                display: flex;
                align-items: center;

                .item-title {
                    margin-left: 12px;
                    margin-right: 8px;

                    .item-title-warnning {
                        display: inline-block;
                        border-radius: 5px;
                        padding: 0 5px;
                        font-size: 12px;
                        color: red;
                        background-color: rgb(254, 240, 240);
                    }
                }

                /deep/ .online-search-switch {
                    display: flex;
                    flex-direction: row;
                    height: 25px;
                    justify-content: space-between;
                    cursor: pointer;
                    position: relative;
                    text-align: center;
                    align-items: center;

                    .el-switch {
                        text-align: center;
                    }

                    .switch-open-icon {
                        position: absolute;
                        // z-index: 999;
                        top: 50%;
                        transform: translateY(-50%);
                        left: 3px;

                        i {
                            color: white;
                            font-size: 16px;
                        }
                    }

                    .switch-close-icon {
                        position: absolute;
                        // z-index: 999;
                        top: 50%;
                        transform: translateY(-50%);
                        left: 21px;

                        i {
                            color: #6e6b7b;
                            font-size: 14px;
                            font-weight: 600;
                        }
                    }

                    i {
                        color: #366aff;
                        font-size: 18px;
                    }

                    .el-switch__core::after {
                        width: 14px;
                        height: 14px;
                        top: 2px;
                        left: 2px;
                    }

                    .is-checked .el-switch__core::after {
                        left: 40px;
                    }

                    &.disabled {

                        i,
                        .el-switch__input,
                        .el-switch__core {
                            cursor: no-drop;
                        }
                    }
                }

            }

            .des {
                margin-top: 12px;
                text-align: left;
                color: #999999;
                font-size: 12px;
                box-sizing: border-box;
                padding: 0 53px;
                white-space: pre-wrap;
            }
        }
    }

    .dialogView {
        width: 375px;
        box-sizing: border-box;
        height: 100%;
        // margin-left: 15px;
        position: absolute;
        border-radius: 4px;
        right: -390px;
        top: 0;
    }

}
</style>
